import type {AnalyticsInstance} from 'analytics';

import {createEzcaterAnalytics, type EzcaterAnalyticsConfig} from '../core/ezcaterAnalytics';

declare global {
  interface Window {
    ezcaterAnalytics?: AnalyticsInstance;
  }
}

const script = document.getElementById('ezcater-analytics-sdk-script');

if (script) {
  const writeKey = script.getAttribute('data-rudderstack-write-key') ?? '';
  const dataPlaneUrl = script.getAttribute('data-rudderstack-data-plane-url') ?? '';
  const serviceName = script.getAttribute('data-service-name') ?? '';
  const serviceVersion = script.getAttribute('data-service-version') ?? undefined;
  const sourceName = script.getAttribute('data-rudderstack-source-name') ?? undefined;
  const sourceId = script.getAttribute('data-rudderstack-source-id') ?? undefined;
  const workspaceId = script.getAttribute('data-rudderstack-workspace-id') ?? undefined;
  const clickTracking = script.hasAttribute('data-enable-click-tracking');

  const config: EzcaterAnalyticsConfig = {
    service: {name: serviceName, version: serviceVersion},
    rudderstack: {writeKey, dataPlaneUrl, sourceName, sourceId, workspaceId},
    clickTracking,
  };

  window.ezcaterAnalytics = createEzcaterAnalytics(config);
}
